
import { Component, Mixins, Watch } from 'vue-property-decorator';
import ResponsivenessMixin from '@/features/common/mixins/responsivenessMixin';
import { NotificationMixin } from '../mixins';

@Component
export default class Customs extends Mixins(NotificationMixin, ResponsivenessMixin) {
  private formData = {
    isHelpfulCountry: {
      show: true,
      name: 'CICountryRequirements',
    },
    isB13a: {
      show: true,
      name: 'B13a',
    },
    isPersonalEffects: {
      show: true,
      name: 'PersonalEffects',
    },
    isNoInsuranceRequested: {
      show: true,
      name: 'NoInsuranceWhenCustomsValueDeclared',
    },
  }

  get isTablet(): boolean {
    return this.$vuetify.breakpoint.lgAndDown;
  }

  @Watch('isNotificationPrefs', { immediate: true })
  private populatePreferences(newValue: boolean) {
    if (newValue) {
      this.formData.isHelpfulCountry.show = this.searchNotificationPref(
        this.formData.isHelpfulCountry.name,
      );
      this.formData.isB13a.show = this.searchNotificationPref(
        this.formData.isB13a.name,
      );
      this.formData.isPersonalEffects.show = this.searchNotificationPref(
        this.formData.isPersonalEffects.name,
      );
      this.formData.isNoInsuranceRequested.show = this.searchNotificationPref(
        this.formData.isNoInsuranceRequested.name,
      );
    }
  }
}
